<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-title-row">
        <button class="editor-back" type="button" aria-label="Indietro" (click)="goBack()">
          <i class="bi bi-arrow-left" aria-hidden="true"></i>
          <span class="back-label">Indietro</span>
        </button>
        <div class="editor-banner">
          <img src="assets/img/contactBar.png" alt="">
          <h1>Nuova scheda</h1>
        </div>
      </div>
      <p class="editor-note">I campi con <sup>*</sup> sono obbligatori.</p>
    </header>

    <form class="editor-form" [formGroup]="articleForm">
      <section class="editor-panel">
        <h2>Classificazione</h2>
        <div class="field-grid field-grid-2">
          <div class="field-block">
            <label for="category">Categoria<sup>*</sup></label>
            <select id="category" class="field" formControlName="category">
              <option [ngValue]="null" disabled>Seleziona una categoria</option>
              @for (item of categoryOptions; track item.id) {
                <option [ngValue]="item">{{ item.title }}</option>
              }
            </select>
          </div>

          <div class="field-block">
            <label for="subCategory">Sottocategoria<sup>*</sup></label>
            <select id="subCategory" class="field" formControlName="subCategory">
              <option [ngValue]="null">Seleziona una sottocategoria</option>
              @for (option of subcategoryOptions; track option.id) {
                <option [ngValue]="option">{{ option.title }}</option>
              }
            </select>
          </div>
        </div>
        @if (!articleForm.get('category')?.value) {
          <p class="editor-hint">Seleziona una categoria per compilare gli altri campi.</p>
        }
      </section>

      <section class="editor-panel">
        <h2>Contenuto</h2>
        <div class="field-stack">
          <div class="field-block">
            <label for="title">Titolo<sup>*</sup></label>
            <input id="title" class="field" type="text" placeholder="Titolo della scheda" formControlName="title">
          </div>
          <div class="field-block">
            <label for="description">Descrizione</label>
            <textarea id="description" class="field field-area" rows="4" placeholder="Descrizione della scheda"
              formControlName="description"></textarea>
          </div>
        </div>
      </section>

      <section class="editor-panel">
        <h2>Data e visibilità</h2>
        <div class="field-grid field-grid-2">
          <div class="field-block">
            <span class="field-label" id="date-format-label">Data</span>
            <div class="format-switch" role="group" aria-labelledby="date-format-label">
              <input type="radio" name="yearFormat" id="date" (click)="changeFormat('date')" [checked]="yearFormat === 'date'">
              <label for="date">Data</label>

              <input type="radio" name="yearFormat" id="year" (click)="changeFormat('year')" [checked]="yearFormat === 'year'">
              <label for="year">Anno</label>

              <input type="radio" name="yearFormat" id="period" (click)="changeFormat('period')" [checked]="yearFormat === 'period'">
              <label for="period">Periodo</label>
            </div>

            @if (yearFormat == 'date') {
              <input class="field" type="date" aria-label="Data" formControlName="date">
            }
            @if (yearFormat == 'year') {
              <input id="year-value" class="field" type="text" placeholder="Anno singolo" formControlName="year"
                (input)="isCorrectYearLogic()"
                [class.is-invalid]="articleForm.get('year')?.invalid && (articleForm.get('year')?.dirty || articleForm.get('year')?.touched)">
            }
            @if (yearFormat == 'period') {
              <div class="period-fields">
                <input id="yearFrom" class="field" type="text" placeholder="Dal" formControlName="yearFrom"
                  (input)="isCorrectPeriodLogic()" [class.is-invalid]="articleForm.get('yearFrom')?.invalid">
                <input id="yearTo" class="field" type="text" placeholder="Al" formControlName="yearTo"
                  (input)="isCorrectPeriodLogic()" [class.is-invalid]="articleForm.get('yearTo')?.invalid">
              </div>
            }
          </div>

          <div class="field-block visibility-block">
            <span class="field-label">Visibilità</span>
            <div class="visibility-controls">
              <label class="switch" for="public">
                <input id="public" type="checkbox" role="switch" formControlName="public" (change)="enableDisablePublication()">
                <span class="switch-track" aria-hidden="true"></span>
                <span>Pubblico</span>
              </label>
              @if (articleForm.get('public')?.value == 1) {
                <input id="public_year" class="field" type="text" inputmode="numeric" maxlength="4" placeholder="Anno" formControlName="public_year"
                  aria-label="Anno pubblicazione"
                  (input)="isCorrectPublicYear()"
                  [class.is-invalid]="articleForm.get('public_year')?.invalid && (articleForm.get('public_year')?.dirty || articleForm.get('public_year')?.touched)">
              }
            </div>
          </div>
        </div>
      </section>

      <section class="editor-panel">
        <h2>Luogo</h2>
        <div class="field-grid field-grid-3">
          <div class="field-block">
            <label for="city">Città</label>
            <input id="city" class="field" type="text" placeholder="Città" matInput [matAutocomplete]="city"
              formControlName="city"
              [class.is-invalid]="articleForm.get('city')?.invalid && (articleForm.get('city')?.dirty || articleForm.get('city')?.touched)">
            <mat-autocomplete #city="matAutocomplete" class="editor-city-panel" panelClass="editor-city-panel"
              [displayWith]="displayCityName">
              @for (option of filteredCity$ | async; track option.id) {
                <mat-option [value]="option">{{ option.name }}</mat-option>
              }
            </mat-autocomplete>
          </div>

          <div class="field-block">
            <label for="pointOfInterest">Luogo d'interesse</label>
            <input id="pointOfInterest" class="field" type="text" placeholder="Luogo" formControlName="pointOfInterest">
          </div>

          <div class="field-block">
            <label for="location">Luogo di conservazione<sup>*</sup></label>
            <input id="location" class="field" type="text" placeholder="Luogo" formControlName="location">
          </div>
        </div>

        <div class="place-grid">
          <div class="field-block">
            <label for="floor">Piano<sup>*</sup></label>
            <input id="floor" class="field" type="text" placeholder="Piano edificio" formControlName="floor">
          </div>
          <div class="field-block">
            <label for="room">Stanza<sup>*</sup></label>
            <input id="room" class="field" type="text" formControlName="room">
          </div>
          <div class="field-block">
            <label for="rack">Scaffale / armadio<sup>*</sup></label>
            <input id="rack" class="field" type="text" formControlName="rack">
          </div>
          <div class="field-block">
            <label for="shelf">Ripiano<sup>*</sup></label>
            <input id="shelf" class="field" type="text" formControlName="shelf">
          </div>
          <div class="field-block">
            <label for="case">Contenitore<sup>*</sup></label>
            <input id="case" class="field" type="text" formControlName="case">
          </div>
        </div>
      </section>

      <div class="editor-actions">
        @if (!articleForm.valid) {
          <p class="editor-hint">Compila correttamente tutti i campi per abilitare il salvataggio.</p>
        }
        <button class="editor-save" type="button" [disabled]="!articleForm.valid" (click)="insertArticle()">
          Salva scheda
        </button>
      </div>
    </form>
  </div>
</div>
